import React, { useState, useEffect } from "react";
import classes from "./Sidebar.module.css";
import logo from "../../Assest/logo.png";
import { NavLink, useLocation } from "react-router-dom";
import {
  FiGrid,
  FiUsers,
  FiCalendar,
  FiUser,
  FiHeart,
  FiPackage,
  FiActivity,
  FiImage,
  FiHome,
  FiScissors,
  FiCreditCard,
  FiShield,
  FiFileText,
  FiArchive,
  FiBarChart2,
  FiSettings,
  FiSun,
  FiMoon,
  FiMenu,
  FiX,
  FiGitBranch,
  FiChevronDown,
  FiChevronRight,
  FiUserPlus,
  FiShield as FiShieldIcon,
  FiLock,
  FiUsers as FiUsersIcon,
  FiClipboard,
  FiPlus,
  FiHeadphones,
  FiSliders,
  FiDatabase,
  FiGlobe,
  FiBell,
  FiTag,
  FiBriefcase,
  FiBookOpen,
  FiMapPin,
  FiClock,
  FiDollarSign,
} from "react-icons/fi";

const Sidebar = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [isLightMode, setIsLightMode] = useState(false);
  const [expandedMenus, setExpandedMenus] = useState({});
  const location = useLocation();

  // Load theme preference from localStorage
  useEffect(() => {
    const savedTheme = localStorage.getItem("sidebarTheme");
    if (savedTheme === "light") {
      setIsLightMode(true);
    }
  }, []);

  // Auto-expand submenus whose child route is active
  useEffect(() => {
    const userManagementPaths = ["/users", "/roles-permissions"];
    const configurationPaths = [
      "/configuration/general",
      "/configuration/departments",
      "/configuration/designations",
      "/configuration/consultation-types",
      "/configuration/wards",
      "/configuration/beds",
      "/configuration/pharmacy-categories",
      "/configuration/lab-tests",
      "/configuration/insurance-providers",
      "/configuration/notifications",
      "/configuration/locations",
      "/configuration/working-hours",
      "/configuration/tax-rates",
    ];

    setExpandedMenus((prev) => {
      const next = { ...prev };
      if (userManagementPaths.includes(location.pathname)) {
        next.userManagement = true;
      }
      if (configurationPaths.includes(location.pathname)) {
        next.configuration = true;
      }
      return next;
    });
  }, [location.pathname]);

  const toggleTheme = () => {
    setIsLightMode(!isLightMode);
    localStorage.setItem("sidebarTheme", !isLightMode ? "light" : "dark");
  };

  const toggleMenu = (menuKey) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menuKey]: !prev[menuKey],
    }));
  };

  const menus = [
    { title: "Dashboard", icon: <FiGrid />, path: "/dashboard" },
    { title: "Reception", icon: <FiHeadphones />, path: "/reception" },
    { title: "Patients", icon: <FiUsers />, path: "/patient" },
    { title: "Appointments", icon: <FiCalendar />, path: "/appointments" },
    // { title: "Doctors", icon: <FiUser />, path: "/doctors" },
    // { title: "Nurses", icon: <FiHeart />, path: "/nurses" },
    { title: "Staff", icon: <FiUsers />, path: "/staff" },
    { title: "Nursing", icon: <FiClipboard />, path: "/nursing" },
    { title: "Department", icon: <FiGitBranch />, path: "/department" },
    { title: "Pharmacy", icon: <FiPackage />, path: "/pharmacy" },
    { title: "Laboratory", icon: <FiActivity />, path: "/laboratory" },
    { title: "Radiology", icon: <FiImage />, path: "/radiology" },
    { title: "Wards & Beds", icon: <FiHome />, path: "/wards" },
    { title: "Theatre", icon: <FiScissors />, path: "/theatre" },
    { title: "Billing & Payments", icon: <FiCreditCard />, path: "/Billings" },
    { title: "Insurance / HMO", icon: <FiShield />, path: "/insurance" },
    { title: "Medical Records(EMR)", icon: <FiFileText />, path: "/medical-records" },
    { title: "Inventory", icon: <FiArchive />, path: "/inventory" },
    { title: "Reports", icon: <FiBarChart2 />, path: "/reports" },

    { title: "Staff Management", icon: <FiUsers />, path: "/staff-management" },

    {
      title: "User Management",
      icon: <FiUsersIcon />,
      path: "#",
      hasSubmenu: true,
      menuKey: "userManagement",
      submenu: [
        { title: "Users", icon: <FiUserPlus />, path: "/users" },
        { title: "Roles & Permissions", icon: <FiShieldIcon />, path: "/roles-permissions" },
      ],
    },

    {
      title: "Configuration",
      icon: <FiSliders />,
      path: "#",
      hasSubmenu: true,
      menuKey: "configuration",
      submenu: [
        { title: "General Settings", icon: <FiSettings />, path: "/configuration/general" },
        { title: "Departments", icon: <FiGitBranch />, path: "/configuration/departments" },
        { title: "Designations", icon: <FiBriefcase />, path: "/configuration/designations" },
        { title: "Consultation Types", icon: <FiBookOpen />, path: "/configuration/consultation-types" },
        { title: "Wards & Beds", icon: <FiHome />, path: "/configuration/wards" },
        { title: "Pharmacy Categories", icon: <FiPackage />, path: "/configuration/pharmacy-categories" },
        { title: "Lab Tests", icon: <FiActivity />, path: "/configuration/lab-tests" },
        { title: "Insurance Providers", icon: <FiShield />, path: "/configuration/insurance-providers" },
        { title: "Tax Rates", icon: <FiDollarSign />, path: "/configuration/tax-rates" },
        { title: "Working Hours", icon: <FiClock />, path: "/configuration/working-hours" },
        { title: "Locations", icon: <FiMapPin />, path: "/configuration/locations" },
        { title: "Notifications", icon: <FiBell />, path: "/configuration/notifications" },
        { title: "System & Data", icon: <FiDatabase />, path: "/configuration/system" },
      ],
    },

    { title: "Settings", icon: <FiSettings />, path: "/settings" },
  ];

  // Check if any submenu item is active
  const isSubmenuActive = (submenuItems) => {
    return submenuItems.some((item) => location.pathname === item.path);
  };

  return (
    <>
      <button
        className={classes.hamburger}
        onClick={() => setShowSidebar(true)}
      >
        <FiMenu />
      </button>

      {showSidebar && (
        <div
          className={classes.overlay}
          onClick={() => setShowSidebar(false)}
        />
      )}

      <aside
        className={`${classes.sidebar} ${isLightMode ? classes.lightMode : classes.darkMode} ${showSidebar ? classes.showSidebar : ""}`}
      >
        <div className={classes.mobileHeader}>
          <button
            className={classes.closeBtn}
            onClick={() => setShowSidebar(false)}
          >
            <FiX />
          </button>
        </div>

        <div className={classes.logoArea}>
          <img
            src={logo}
            alt="logo"
            className={`${classes.logo} ${isLightMode ? classes.logoLight : classes.logoDark}`}
          />
          <div>
            <h3 className={isLightMode ? classes.lightText : classes.darkText}>
              City Care
            </h3>
            <span className={isLightMode ? classes.lightSubText : classes.darkSubText}>
              Hospital
            </span>
          </div>
        </div>

        <div className={classes.menu}>
          {menus.map((item, index) => (
            <div key={index}>
              {item.hasSubmenu ? (
                <div>
                  <div
                    className={`${classes.item} ${classes.submenuParent} ${
                      isSubmenuActive(item.submenu) ? classes.active : ""
                    }`}
                    onClick={() => toggleMenu(item.menuKey)}
                  >
                    <span className={classes.icon}>{item.icon}</span>
                    <p>{item.title}</p>
                    <span className={classes.chevron}>
                      {expandedMenus[item.menuKey] ? (
                        <FiChevronDown />
                      ) : (
                        <FiChevronRight />
                      )}
                    </span>
                  </div>
                  {expandedMenus[item.menuKey] && (
                    <div className={classes.submenu}>
                      {item.submenu.map((subItem, subIndex) => (
                        <NavLink
                          key={subIndex}
                          to={subItem.path}
                          className={({ isActive }) =>
                            `${classes.subItem} ${isActive ? classes.activeSubItem : ""}`
                          }
                          onClick={() => setShowSidebar(false)}
                        >
                          <span className={classes.subIcon}>{subItem.icon}</span>
                          <p>{subItem.title}</p>
                        </NavLink>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `${classes.item} ${isActive ? classes.active : ""}`
                  }
                  onClick={() => setShowSidebar(false)}
                >
                  <span className={classes.icon}>{item.icon}</span>
                  <p>{item.title}</p>
                </NavLink>
              )}
            </div>
          ))}
        </div>

        <div className={classes.bottom}>
          <div className={classes.mode} onClick={toggleTheme}>
            <div className={classes.leftMode}>
              {isLightMode ? <FiMoon /> : <FiSun />}
              <span>{isLightMode ? "Dark Mode" : "Light Mode"}</span>
            </div>
            <div className={`${classes.switch} ${isLightMode ? classes.switchActive : ""}`}>
              <div className={`${classes.circle} ${isLightMode ? classes.circleActive : ""}`}></div>
            </div>
          </div>
          <p className={isLightMode ? classes.lightFooter : classes.darkFooter}>
            © 2024 City Care Hospital
            <br />
            All rights reserved.
          </p>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;